import { AnalyticsEvent } from '../analytics-event';

export type UserActionName =
  | 'checkout'
  | 'renewal'
  | 'hold'
  | 'create_list'
  | 'follow_list'
  | 'follow_author'
  | 'mark_as_read'
  | 'delete_all_notifications'
  | 'notification_read'
  | 'notification_deleted'
  | 'support_form'
  | 'add_favorite'
  | 'remove_favorite'
  | 'add_to_list'
  | 'remove_from_list'
  | 'edit_list'
  | 'delete_list'
  | 'share_list'
  | 'unfollow_list'
  | 'list_detail'
  | 'unfollow_author'
  | 'remove_all_authors'
  | 'send_rating'
  | 'send_comment'
  | 'delete_comment'
  | 'like_comment'
  | 'dislike_comment'
  | 'share_tdp'
  | 'carousel_tdp'
  | 'carousel_detail'
  | 'preview'
  | 'return_checkout'
  | 'tap_banner'
  | 'search_saved'
  | 'search_link_copied'
  | 'history_exported_to_excel'
  | 'history_exported_to_pdf'
  | 'item_removed_from_history'
  | 'monthly_challenge_created'
  | 'daily_challenge_created'
  | 'monthly_position_viewed'
  | 'monthly_points_viewed'
  | 'general_position_viewed'
  | 'general_points_viewed';

type UserActionEventProps = {
  page_name: string;
  action_name: UserActionName;
  is_successful: boolean;
};

export class UserActionEvent implements AnalyticsEvent<UserActionEventProps> {
  readonly name = 'user_action';
  readonly props: UserActionEventProps;

  constructor(props: UserActionEventProps) {
    this.props = props;
  }
}
